import { render, staticRenderFns } from "./Developments.vue?vue&type=template&id=b58d2548"
import script from "./Developments.vue?vue&type=script&lang=js"
export * from "./Developments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports